import { useSelector } from 'react-redux'
import { sensorSelector } from '@src/selectors/sensor'
import { useDexcomConnection, useIsActiveDexcom } from '@src/utils/hooks'
import { useIsIndirectSyncSensorMode, useSyncsGlucoseViaAppleOrGoogle } from '../hooks'
import { useIsOwnSensorGlucoseDetected } from './useIsOwnSensorGlucoseDetected'
import { useShowByosDataInfoUi } from './useShowByosDataInfoUi'

export const useShowByosIntegrationWarning = () => {
  const currentSensor = useSelector(sensorSelector)

  // Has a relevant sensor mode or syncing configuration
  const isActiveDexcom = useIsActiveDexcom()
  const syncsGlucoseViaAppleOrGoogle = useSyncsGlucoseViaAppleOrGoogle()
  const isIndirectSyncSensorMode = useIsIndirectSyncSensorMode()
  const hasEligibleSensorMode =
    isActiveDexcom || syncsGlucoseViaAppleOrGoogle || isIndirectSyncSensorMode

  // User has already synced via BYOS successfully in the past
  const isOwnSensorGlucoseDetected = useIsOwnSensorGlucoseDetected()

  const dexcomConnection = useDexcomConnection()

  // User is eligible for BYOS integration UI
  const showByosDataInfoUi = useShowByosDataInfoUi()

  const thirdPartyWarning =
    showByosDataInfoUi &&
    hasEligibleSensorMode &&
    !isOwnSensorGlucoseDetected &&
    !dexcomConnection &&
    !currentSensor

  return { thirdPartyWarning }
}

export const useIsByosIntegrationWarning = () => {
  const { thirdPartyWarning } = useShowByosIntegrationWarning()

  return thirdPartyWarning
}
